/* eslint-disable */

import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';

declare const window: any;
declare const webkit: any;

@Injectable({
  providedIn: 'root'
})
export class NativeBridgeService {
  private locationUpdate$ = new Subject<{ latitude: number; longitude: number }>();
  locationUpdate = this.locationUpdate$.asObservable();

  constructor(private zone: NgZone) {
    this.setupNativeListener();
    this.setupCallbacksFromNative();
    this.listenForNativeMessages();
  }

  // Call native function from Angular
  callNativeFunction(data: any) {
    if (window['nativeInterface']) {
      window['nativeInterface'].postMessage(JSON.stringify(data));
    } else {
      console.warn('Native interface not available');
    }
  }

  // Set up listener for messages from native code
  private setupNativeListener() {
    window['onNativeMessage'] = (data: any) => {
      const parsedData = JSON.parse(data);
      // Handle the message from native code
    };
  }

  public setupCallbacksFromNative(): void {
    window.sendJwt = () => {
      this.zone.run(() => {
        // this.authService.setAuthInfo({ jwt});
        // this.router.navigate(['/']);
      });
    };

    window.handleBackKey = () => {
      this.zone.run(() => {});
    };
  }

  sendAuthTokens(
    accessToken: string,
    accessTokenExpiresIn: number,
    refreshToken: string,
    refreshTokenExpiresIn: number
  ): void {
    const payload = {
      type: 'authTokens',
      value: {
        accessToken,
        accessTokenExpiresIn,
        refreshToken,
        refreshTokenExpiresIn
      }
    };

    const encodedPayload = btoa(JSON.stringify(payload));
    this.externalCall(encodedPayload);
  }

  sendAuthToken(token: string): void {
    this.externalCall(
      btoa(
        JSON.stringify({
          type: 'authToken',
          value: token
        })
      )
    );
  }

  launchBrowser(url: string): void {
    this.externalCall(
      btoa(
        JSON.stringify({
          type: 'launchbrowser',
          value: url
        })
      )
    );
  }
  hideLocation(): void {
    this.externalCall(
      btoa(
        JSON.stringify({
          type: 'hideLocation'
        })
      )
    );
  }
  showLocation(): void {
    this.externalCall(
      btoa(
        JSON.stringify({
          type: 'showLocation'
        })
      )
    );
  }

  tokenExpired(): void {
    this.externalCall(
      btoa(
        JSON.stringify({
          type: 'authTokenExpired'
        })
      )
    );
  }

  /** WebView → native: read GPS and post LOCATION_UPDATE back to the WebView. */
  requestLocation(): void {
    this.externalCall(
      btoa(
        JSON.stringify({
          type: 'requestLocation'
        })
      )
    );
  }

  logout(): void {
    this.externalCall(
      btoa(
        JSON.stringify({
          type: 'logout'
        })
      )
    );
  }

  private listenForNativeMessages(): void {
    window.addEventListener('message', (event: MessageEvent) => {
      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        if (data?.type === 'LOCATION_UPDATE' && data?.payload) {
          this.zone.run(() => {
            this.locationUpdate$.next({
              latitude: data.payload.latitude,
              longitude: data.payload.longitude
            });
          });
        }
      } catch (e) {
        // Not a JSON message, ignore
      }
    });
  }

  redirectToDashboard(): void {
    this.externalCall(
      btoa(
        JSON.stringify({
          type: 'dashboardRedirect'
        })
      )
    );
  }

  private externalCall(data: string): void {
    try {
      if (window.android && window.android.__externalCall) {
        window.android.__externalCall(data);
      }
      if (window.__externalCall) {
        window.__externalCall(data);
      }
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(data);
      }
      webkit.messageHandlers.callback.postMessage(data);
    } catch (e) {
    }
  }
}
